import { newAction, replaceStep } from '../../utils/actions'
import { sort } from '../../utils/arrays'
import { buildIndex } from '../../utils/indexing'
import * as API from '../../utils/api'
import { LOGOUT } from '../users'

const FETCH_ACTIONS = 'FETCH_ACTIONS'
const FETCH_ACTION = 'FETCH_ACTION'

const UPDATE_ACTION = 'UPDATE_ACTION'
const CREATE_ACTION = 'CREATE_ACTION'

const INITIAL_STATE = {
  actions: {},
  loading: false,
}

// Reducer

export default (state = INITIAL_STATE, action) => {
  if (
    action.type === `${UPDATE_ACTION}_FULFILLED` ||
    action.type === `${CREATE_ACTION}_FULFILLED`
  ) {
    let actionObj = action.payload.data

    let { id } = actionObj
    let oldAction = state.actions[id]

    if (oldAction) {
      actionObj = {
        ...oldAction,
        ...actionObj,
      }
    }

    return {
      ...state,
      actions: {
        ...state.actions,
        [id]: actionObj,
      },
    }
  }

  // Fetch Actions

  if (action.type === `${FETCH_ACTIONS}_PENDING`) {
    return { ...state, loading: true }
  }

  if (action.type === `${FETCH_ACTIONS}_REJECTED`) {
    return { ...state, loading: false }
  }

  if (action.type === `${FETCH_ACTIONS}_FULFILLED`) {
    let actions = action.payload.data

    return {
      ...state,
      actions: {
        ...state.actions,
        ...buildIndex(actions, action => action.id),
      },
      loading: false,
    }
  }

  // Fetch Individual

  if (action.type === `${FETCH_ACTION}_FULFILLED`) {
    let actionObj = action.payload.data

    return {
      ...state,
      actions: {
        ...state.actions,
        [actionObj.id]: actionObj,
      },
    }
  }

  if (action.type === LOGOUT) {
    return INITIAL_STATE
  }

  return state
}

// Actions

export const fetchActions = organizationId => ({
  type: FETCH_ACTIONS,
  payload: API.fetchActions(organizationId),
})

export const fetchAction = id => ({
  type: FETCH_ACTION,
  payload: API.fetchAction(id),
})

export const createAction = (organizationId, firstStep) => ({
  type: CREATE_ACTION,
  payload: API.createAction(
    organizationId,
    newAction('Untitled Action', firstStep)
  ),
})

export const updateAction = (actionId, action) => ({
  type: UPDATE_ACTION,
  payload: API.saveAction(actionId, action),
})

export const addStep = (actionId, step) => dispatch => {
  return dispatch(updateStep(actionId, step.id, step))
}

export const addInput = (actionId, input) => (dispatch, getState) => {
  let action = getAction(actionId)(getState())
  let inputs = (action.details && action.details.inputs) || []

  inputs = inputs.concat(input)

  return dispatch(updateStep(actionId, null, null, inputs))
}

export const saveInputs = (actionId, inputs) => dispatch => {
  return dispatch(updateStep(actionId, null, null, inputs))
}

export const updateStep = (actionId, stepId, step, inputs) => (
  dispatch,
  getState
) => {
  let action = getAction(actionId)(getState())

  if (stepId && step) {
    action = replaceStep(action, stepId, step)
  }

  if (inputs) {
    action.details.inputs = inputs
  }

  return dispatch({
    type: UPDATE_ACTION,
    payload: API.saveAction(actionId, action),
  })
}

// Selectors

export const getAction = id => state => {
  let action = state.actions.actions[id]

  return action
}

export const getActions = (organizationId, draft = false) => state => {
  let actions = Object.values(state.actions.actions).filter(action => {
    return (
      action.OrganizationId === organizationId &&
      action.id !== 'new' &&
      action.draft === draft
    )
  })

  // Sort alphabetically
  return sort(actions, action => action.name)
}

export const getStep = (actionId, stepId) => state => {
  let action = getAction(actionId)(state)

  let step =
    action &&
    action.details &&
    action.details.steps &&
    action.details.steps.filter(step => step.id === stepId)[0]

  return step
}

export const getLoading = state => {
  return state.actions.loading
}
